<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "InviteRewards",
  components: {CommonTable},
  data() {
    return {
      searchs: [
        {
          name: 'agentId',
          placeholder: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
        },{
          name: 'parentPhone',
          placeholder: '上级用户名',
          type: 'input'
        },{
          name: 'phone',
          placeholder: '用户名',
          type: 'input'
        },
      ],
      permission: {
        add: 'inviteRewards:add',
        update: 'inviteRewards:update',
        delete: 'inviteRewards:delete',
        deleteBatch: 'inviteRewards:deleteBatch'
      },
      url: {
        get: '/inviteRewards/listByCondition',
        add: '/inviteRewards/add',
        update: '/inviteRewards/update',
        delete: '/inviteRewards/delete/',
        delete_batch: '/inviteRewards/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '',
      }, {
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      }, {
        field: 'parentPhone',
        label: '上级',
        show: true,
        width: '',
      }, {
        field: 'reward',
        label: '奖励金额',
        show: true,
        width: '',
      }, {
        field: 'firstChargeMoney',
        label: '首充金额',
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '会员邀请奖励',
        toTree:false,
        updateTitle: '会员邀请奖励',
        model: [{
          field: 'agentId',
          label: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
          placeholder: '请选择',
          rules: [{
            message: '请选择代理', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'userId',
          label: '用户ID',
          type: 'textarea',
          placeholder: '用户ID',
          rules: [{message: '请输入用户ID', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'parentId',
          label: '上级ID',
          type: 'textarea',
          placeholder: '上级ID',
          rules: [{message: '请输入上级ID', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'reward',
          label: '奖励金额',
          type: 'textarea',
          placeholder: '奖励金额',
          rules: [{message: '请输入奖励金额', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'firstChargeMoney',
          label: '首充金额',
          type: 'textarea',
          placeholder: '首充金额',
          rules: [{message: '请输入首充金额', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
